export default __webpack_public_path__ + "assets/images/c7a66f421f26d35b8524ae87694651f4.png";